import { OktaAuth, toRelativeUrl } from '@okta/okta-auth-js';
import { Security, LoginCallback } from '@okta/okta-react';
import { useNavigate } from 'react-router-dom';
import { config } from '../config';

const oktaAuth = config.oktaIssuer && config.oktaClientId
  ? new OktaAuth({
      issuer:   config.oktaIssuer,
      clientId: config.oktaClientId,
      redirectUri: `${window.location.origin}/login/callback`,
      scopes: ['openid', 'profile', 'email'],
      pkce: true,
    })
  : null;

function OktaSecurity({ children }: { children: React.ReactNode }) {
  const navigate = useNavigate();
  const restoreOriginalUri = (_oktaAuth: OktaAuth, originalUri: string) => {
    navigate(toRelativeUrl(originalUri || '/', window.location.origin), { replace: true });
  };

  if (!oktaAuth) return <>{children}</>;

  return (
    <Security oktaAuth={oktaAuth} restoreOriginalUri={restoreOriginalUri}>
      {children}
    </Security>
  );
}

export { OktaSecurity, LoginCallback };
export { oktaAuth };
